// @ts-ignore
// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { useEffect } from "react"
import { GridCallbackDetails, GridSelectionModel } from "@mui/x-data-grid-pro"

import { useTableContext } from "../provider"
import { SelectionMode } from "../components/Selection"

export const useSelection = () => {

  const ctx = useTableContext()

  useEffect(() => {
    // console.log(`[SELECTION] Initial state`)
    // console.log(ctx.props.selectionInitial)
    const ids = ctx.props.selectionInitial || []
    ctx.muiGridApiRef.current.setSelectionModel(ids)
  }, [])

  const onSelectionModelChange = (model: GridSelectionModel) => {

    if (ctx.props.onSelectionModelChange) {
      ctx.props.onSelectionModelChange(model)
    }

    const selectedRowKeys_ = model as (string[])
    const selectedCount = selectedRowKeys_.length

    if (selectedCount === 0) {
      ctx.selection.api.setMode(SelectionMode.Nothing)
      return
    }

    const ids = ctx.muiGridApiRef.current.getAllRowIds()
    const rowsCount = ids.length

    // ASSERT(selectedRowKeys_.length > 0)

    if (selectedCount < rowsCount) {
      ctx.selection.api.setMode(SelectionMode.Partial)
      return
    }

    if (selectedCount === rowsCount) {
      ctx.selection.api.setMode(SelectionMode.Page)
      return
    }
  }

  return {
    onSelectionModelChange,
  }
}

